import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const ToolbarCenterTextIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={32}
        height={32}
        viewBox="0 0 32 32"
        className="Icon toolbar-center-text"
        {...props}
    >
        <g fill="none" fillRule="evenodd">
            <rect width={32} height={32} fill="#EBEDEE" rx={4} />
            <path
                fill="#48505E"
                d="M22 20.25a.75.75 0 0 1 0 1.5H10a.75.75 0 0 1 0-1.5zm-1-5a.75.75 0 0 1 0 1.5H11a.75.75 0 0 1 0-1.5zm2-5a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1 0-1.5z"
            />
        </g>
    </svg>
);
const Memo = memo(ToolbarCenterTextIcon);
export default Memo;
